import CryptoJS from 'crypto-js'

const SECRET_KEY =
  process.env.REACT_APP_LOCAL_STORAGE_SECRET || 'vehicle_secret'

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString()
}

export const decryptData = (cipher) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipher, SECRET_KEY)
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
  } catch {
    return null
  }
}

const STORAGE_KEY = 'encrypted_registration_token'

export const saveEncrypted = (key, data, expiryTime) => {
  const payload = {
    data,
    expiry: Date.now() + expiryTime,
  }

  const encrypted = encryptData(payload)
  localStorage.setItem(key, encrypted)
}

export const loadEncrypted = (key) => {
  try {
    const stored = localStorage.getItem(key)
    if (!stored) return null

    const decrypted = decryptData(stored)
    if (!decrypted) return null

    if (Date.now() > decrypted.expiry) {
      localStorage.removeItem(key)
      return null
    }

    return decrypted.data
  } catch {
    return null
  }
}

export const removeEncrypted = (key) => {
  localStorage.removeItem(key)
}
